import { Image, useColorMode } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

import * as S from './styled'

export const Logo = () => {
  const navigate = useNavigate()
  const { colorMode } = useColorMode()
  const logoImage = colorMode === 'light' ? 'logo-dark.png' : 'logo-light.png'

  return (
    <S.Header onClick={() => navigate('/')}>
      <Image src={logoImage} />
    </S.Header>
  )
}
